// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c3e18103","239":"fb43e5b6","455":"36d6f4e6","557":"ba191ea4","762":"4d5299bb"}[chunkId] + ".chunk.js";
};